import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiClient from '../../api/client';
import { queryKeys } from '../../api/queryKeys';

export const useGetCartCounts = () => {
  const { data, isLoading, refetch } = useQuery(
    queryKeys.cart.counts,
    () => apiClient.get('product/get_cart_counts').then((res) => res.data),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
  return { data, isLoading, refetch };
};

export const useGetCartData = () => {
  const { data, isLoading, error, mutate, refetch } = useQuery(
    queryKeys.cart.product,
    () => apiClient.get('product/get_cart_products').then((res) => res.data),
    {
      staleTime: 1 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.error('Error fetching cart data:', error);
      },
    },
  );
  return { data, isLoading, error, mutate, refetch };
};

export const useGetVoucherCartData = () => {
  const { data, isLoading, error, mutate, refetch } = useQuery(
    queryKeys.cart.voucher,
    () => apiClient.get('voucher/get_cart_vouchers').then((res) => res.data),
    {
      staleTime: 1 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.error('Error fetching voucher cart data:', error);
      },
    },
  );
  return { data, isLoading, error, mutate, refetch };
};

export const useGetMediaCartData = () => {
  const { data, isLoading, error, mutate, refetch } = useQuery(
    queryKeys.cart.media,
    () =>
      apiClient.get('media/get_media_cart').then((res) => {
        const cartData = res?.data?.body || res?.data;
        return Array.isArray(cartData) ? cartData : [];
      }),
    {
      staleTime: 2 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      onError: (error) => {
        console.error('Error fetching media cart data:', error);
      },
    },
  );
  return { data, isLoading, error, mutate, refetch };
};

export const useUpdateProductCartQty = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ cartid, NewQty, productId, productVariationId }) =>
      apiClient.put('product/update_cart_qty', {
        cartid,
        NewQty,
        productId,
        productVariationId,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.cart.product);
        queryClient.invalidateQueries(queryKeys.cart.counts);
      },
    },
  );
};

export const useUpdateVoucherCartQty = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ cartid, NewQty, productId, productVariationId }) =>
      apiClient.post('voucher/update_voucher_cart_qty', {
        cartid,
        NewQty,
        productId,
        productVariationId,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.cart.voucher);
        queryClient.invalidateQueries(queryKeys.cart.counts);
      },
    },
  );
};


